export default class {
    constructor(id, date, isTodayDate, doctor, chair) {
        this.id = id
        this.date = date
        this.isTodayDate = isTodayDate
        this.doctor = doctor
        this.chair = chair
    }
}
